import Cookies from "js-cookie";
import { uniqBy } from "lodash";
const TokenKey = "token";
const UserKey = "user";
const QrcodeKey = "qrcode";
const PermissionFilterKey = "PermissionFilter";

export function getToken() {
  return Cookies.get(TokenKey);
}

export function setToken(token) {
  return Cookies.set(TokenKey, token, {
    expires: getTokenFailureTime() ? new Date(+getTokenFailureTime()) : 7
  });
}

export function removeToken() {
  return Cookies.remove(TokenKey);
}

export function getUser() {
  const value = Cookies.get(UserKey);
  return value && typeof value === "string" ? JSON.parse(value) : value;
}

export function setUser(user) {
  return Cookies.set(UserKey, user, {
    expires: getTokenFailureTime() ? new Date(+getTokenFailureTime()) : 7
  });
}

export function removeUser() {
  return Cookies.remove(UserKey);
}

export function getQrcode() {
  return Cookies.get(QrcodeKey);
}

export function setQrcode({ qrcode, expireTime }) {
  return Cookies.set(QrcodeKey, qrcode, {
    expires: (expireTime - Date.now()) / 1000 / 3600
  });
}

/**
 * 用于存放第一次登录的失效时间,避免账号时时间重写
 */
export function setTokenFailureTime() {
  // Date.now() + 7(天数值) * 864e5
  return localStorage.setItem("TokenFailureTime", Date.now() + 7 * 864e5);
}
export function getTokenFailureTime() {
  return localStorage.getItem("TokenFailureTime");
}
export function removeTokenFailureTime() {
  return localStorage.removeItem("TokenFailureTime");
}
/**
 * 用于忽略越权页面跳转 因需要单独开放页面访问
 */
export function getPermissionFilter() {
  return Cookies.get(PermissionFilterKey);
}

export function setPermissionFilter({ data, num = 1 }) {
  let data2 = data;
  let data3 = getPermissionFilter();
  if (data3) {
    const parse = uniqBy([...JSON.parse(data3), ...data2], "path");
    data2 = [...parse];
  }
  return Cookies.set(PermissionFilterKey, data2, {
    expires: new Date(new Date().getTime() + num * 60 * 60 * 1000)
  });
}

export function removePermissionFilter() {
  return Cookies.remove(PermissionFilterKey);
}
